<template>
  <div id="app">
    <nav class="navbar" v-if="this.$route.name !== 'asset-create-open'">
       <TopBar></TopBar>
    </nav>
     <SideBar ref="sidebar" v-if="this.$route.meta.requireAuth === true"></SideBar>
    <router-view/>
  </div>
</template>

<script>
import TopBar from './components/TopBar'
import SideBar from './components/SideBar'

export default {
  name: 'App',
  components:{
      TopBar,
      SideBar
  }
}
</script>

<style>
@import '../static/plugins/bootstrap/css/bootstrap.css';
@import '../static/css/style.css';
@import '../static/css/fn-style.css';
@import '../static/css/theme-blue.css';
@import '../static/plugins/light-gallery/css/lightgallery.css';
@import '../static/plugins/node-waves/waves.css';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue